var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaButtonIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "launch_24px_rounded 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M15,16 L3,16 C2.45,16 2,15.55 2,15 L2,3 C2,2.45 2.45,2 3,2 L8,2 C8.55,2 9,1.55 9,1 C9,0.45 8.55,0 8,0 L2,0 C0.89,0 0,0.9 0,2 L0,16 C0,17.1 0.9,18 2,18 L16,18 C17.1,18 18,17.1 18,16 L18,10 C18,9.45 17.55,9 17,9 C16.45,9 16,9.45 16,10 L16,15 C16,15.55 15.55,16 15,16 Z M11,1 C11,1.55 11.45,2 12,2 L14.59,2 L5.46,11.13 C5.07,11.52 5.07,12.15 5.46,12.54 C5.85,12.93 6.48,12.93 6.87,12.54 L16,3.41 L16,6 C16,6.55 16.45,7 17,7 C17.55,7 18,6.55 18,6 L18,0 L12,0 C11.45,0 11,0.45 11,1 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-1028, -171)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "launch_24px_rounded-1",
    transform: "translate(1028, 171)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#2773FF",
    fillRule: "nonzero",
    mask: "url(#mask-2)",
    points: "21 -3 -3 -3 -3 21 21 21"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaButtonIcon);
export default __webpack_public_path__ + "static/media/WA_button_Icon.a2559f55e436a0037083d527f4a5ae1e.svg";
export { ForwardRef as ReactComponent };